import * as types from './agenda-items.types';

export const agendaItemsPageSelectors: types.IAgendaItemsPageSelectors = {
  selectAgendaItems: (state) => state.page.agendaItems.agendaItems,
  selectCurrentAgenda: (state) => state.page.agendaItems.currentAgendaIndex,
};
